<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="480"
      max-height="400"
      max-width="480"
      class="mt-4"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="messages"
          :value="messages"
          color="#294697"
          overlap
          class="mr-5"
        >
          <v-icon
            medium
            v-bind="attrs"
            v-on="on"
            color="#294697"
            class="mr-2"
          >
            {{ notification ? "mdi-bell-ring" : "mdi-bell-outline" }}
          </v-icon>
        </v-badge>
      </template>
      <v-card class="pa-1">
        <v-card-title>NOTIFICACIONES </v-card-title>
        <v-card-text
          v-for="n in notificationsObjects"
          :key="n.idNotificaciones"
        >
          <v-card
            class="mx-auto my-1"
            style="background-color: #1D3C7F; border: 1px solid #1D3C7F"
            dark
            outlined
            elevation="4"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="text-overline mb-4">{{ n.title }}</div>
                <v-list-item-title class="text-h7 mb-1 titulo">
                  NOVA
                </v-list-item-title>
                <v-list-item-subtitle class="text-h8 mb-1 font-weight-medium">{{
                  n.sub
                }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-h8 mensaje">
                  {{ n.msg }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar size="60">
                <v-img
                  class="white"
                  :src="require(`../../assets/iconos/customer-service.png`)"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>
            <v-card-actions width="480">
              <div
                class="d-flex flex-row justify-space-between"
                style="width: 100%"
              >
                <div class="fecha">
                  Fecha de notificacion: <br />
                  <span class="fecha-span"> {{ n.fecha }}</span>
                </div>
                <div>
                  <p class="texto-calificacion" style="margin: 0px">
                    CALIFICA EL SERVICIO
                  </p>
                  <v-rating
                    color="#294697"
                    v-model="n.calificacion"
                    dense
                    size="30"
                  ></v-rating>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div
                class="d-flex justify-end"
                style="width: 100%"
                v-if="n.calificacion > 0"
              >
                <v-btn
                  :loading="loading"
                  small
                  @click="calificar(n)"
                  tile
                  color="green accent-4"
                  dark
                >
                  CALIFICAR
                  <v-icon right small> mdi-check </v-icon>
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false"> CERRAR </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import axios from "axios";
import env from "@/components/env";
export default {
  name: "Notificaciones",

  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    messages: {
      type: Number,
      default: 0,
    },
    notification: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      rating: 0,
      loading: false,
    };
  },
  computed: {
    notificationsObjects() {
      const data = [];
      for (let i = 0; i < this.notifications.length; i++) {
        this.notifications[i].calificacion = parseInt(
          this.notifications[i].calificacion
        );
        data.push(this.notifications[i]);
      }
      return data;
    },
  },
  methods: {
    calificar(data) {
      // console.log(data);
      this.loading = true;
      setTimeout(() => {
        axios
          .get(
            `${env.endpoint}user/calificar?idNotificaciones=${data.idNotificaciones}&calificacion=${data.calificacion}`
          )
          .then((res) => {
            // console.log(res.data);
          })
          .catch((error) => {
            console.error(error.message);
          })
          .finally(() => {
            this.loading = false;
            this.$emit("custom-click");
          });
      }, 1500);
    },
  },
};
</script>

<style scoped>
.fecha {
  font-size: 11px;
}
.fecha-span {
  font-weight: 600;
}
.texto-calificacion {
  font-size: 11px;
  font-weight: 600;
  background: #f9f9f9;
  padding-left: 8px;
  color: #000;
  text-align: center;
}

.mensaje {
  color: #000000 !important;
  border: 1px solid #fefefe;
  font-size: 13px;
  border-radius: 4px;
  padding: 7px;
  margin-top: 7px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: inline-block;
}
.titulo {
  background: #f9f9f9;
  padding: 9px;
  border-radius: 2px;
  text-align: center;
  color: #171717;
}
</style>